//@ts-check
import React from 'react';
import Page from '../../../../../page';
import JobProgress from './JobProgress';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
/**
 * @param {import('./types').JobToolbarProps} param
 */

var JobToolbar = function JobToolbar(_ref) {
  var job = _ref.job,
      title = _ref.title,
      onClose = _ref.onClose,
      center = _ref.center;
  var progress = job.Progress;
  var stage = job.Stage;
  return React.createElement(Page.ToolBar, {
    color: "navbar",
    icon: onClose ? {
      type: 'close',
      onClick: onClose
    } : null,
    leftChildren: title || '',
    centerChildren: React.createElement(Grid, {
      container: true,
      direction: "row",
      justify: "center",
      alignItems: "center",
      spacing: 2,
      style: {
        margin: -7 // safari fix (https://github.com/mui-org/material-ui/issues/17142)

      }
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(JobProgress, {
      progress: progress,
      status: stage
    })), React.createElement(Grid, {
      item: true
    }, center && React.createElement(Typography, {
      style: {
        color: 'black'
      }
    }, center)))
  });
};

export default JobToolbar;